/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';

import { CardCarousel } from '@/exceed';

import getCoverArtUrl from '../helpers/getCoverArtUrl';

import VideosCard from '../common/videosCard';
import VideoLiveAndUpcomingCardMedia from './videoLiveAndUpcomingCardMedia';

import styles from '../styles/videoLiveAndUpcoming.module.scss';

const VideoLiveAndUpcoming = ({ liveAndUpcoming, isLoading }) => {
  const [isSkeletonLoading, setIsSkeletonLoading] = useState(isLoading);

  useEffect(() => {
    if (isLoading === false) {
      setIsSkeletonLoading(true);
      setTimeout(() => {
        setIsSkeletonLoading(false);
      }, 2000);
    }
  }, [isLoading]);

  return (
    <div>
      <CardCarousel title={i18n.t('live-and-upcoming')}>
        {liveAndUpcoming?.map((video) => (
          <div className={styles.contentItem} key={video.id}>
            <VideosCard
              id="video-live-and-upcoming-card"
              isSkeletonLoading={isSkeletonLoading}
              link={`/student/videos/live/${video.id}`}
              className={styles.item_card}
              meta={video.start_at}
              metaIcon="calendar"
              title={video.name}
              reputation={video.metadata && video.metadata.reputation}
              image={getCoverArtUrl(video.cover_art)}
              shouldShowLiveStatus
              shouldShowPlayIcon
              videoType="live"
              cardMedia={
                <VideoLiveAndUpcomingCardMedia startAt={video.start_at} endAt={video.end_at} />
              }
            />
          </div>
        ))}
      </CardCarousel>
      <div className={styles.viewAllContainer}>
        <Button text={i18n.t('view-all')} variant="soft" to="/student/videos/live" />
      </div>
    </div>
  );
};

VideoLiveAndUpcoming.propTypes = {};

export default React.memo(VideoLiveAndUpcoming);
